import { Col, DatePicker, Form, FormInstance, Input, Radio } from 'antd'

import { requiredRules } from 'src/app-constants'
import { dayMonthYearFormatWithDot, disabledFutureDate } from 'src/libs'
import { useLocales } from 'src/locales'

type Props = {
  form: FormInstance
}

export const HospitalizationSymptomsCard = ({ form }: Props) => {
  const { t } = useLocales()

  const hasHospitalization =
    Form.useWatch(['form', 'symptoms', 'hospitalization', 'status'], form) ===
    'yes'

  return (
    <>
      <Col span={24}>
        <Form.Item
          name={['form', 'symptoms', 'hospitalization', 'status']}
          rules={requiredRules}
          label={`10. ${t('epidemiology.hospitalization')}`}
        >
          <Radio.Group>
            <Radio value="dontKnow">{t('epidemiology.unknown')}</Radio>
            <Radio value="no">{t('common.no')}</Radio>
            <Radio value="yes">{t('common.yes')}</Radio>
          </Radio.Group>
        </Form.Item>
      </Col>

      {hasHospitalization && (
        <>
          <Col span={12}>
            <Form.Item
              name={[
                'form',
                'symptoms',
                'hospitalization',
                'hospitalInstitution',
                'title',
                'value'
              ]}
              label="Denumirea instituției"
            >
              <Input placeholder="Denumirea instituției" />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              name={[
                'form',
                'symptoms',
                'hospitalization',
                'hospitalInstitution',
                'hospitalizationDate',
                'value'
              ]}
              label="Data spitalizării"
            >
              <DatePicker
                className="full-width"
                disabledDate={disabledFutureDate}
                format={dayMonthYearFormatWithDot}
                placeholder="Data spitalizării"
              />
            </Form.Item>
          </Col>
        </>
      )}
    </>
  )
}
